export default __webpack_public_path__ + "static/media/portaplasticos.4839b5e5.png";